import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';

Component('tr-project-kanban-toolbar', {
  mixins: [eventListenerMixin],

  connected() {
    this.listenTo(
      this.querySelector('.js-toggle-fullscreen'),
      'click',
      this.handleToggleClick.bind(this),
    );
  },

  handleToggleClick() {
    document.body.classList.toggle('body-fullscreen');
    this.namespacedTrigger('fullscreen', {
      detail: document.body.classList.contains('body-fullscreen'),
    });
    const fullscreenPage = document.querySelector('tr-fullscreen-page');
    if (fullscreenPage) fullscreenPage.setHeight();
  },

  disconnected() {
    this.stopListening();
  },
});
